// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    background-color: rgb(22, 13, 13);
    overflow: hidden;
}

#root {
    height: 100vh;
    width: 100vw;
}

.menu-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 1.5px;
}

.compact-sidebar {
  transition: width 0.3s ease;
}

@media (max-width: 1200px) {
  .compact-sidebar {
    width: 60px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/index.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\nbody {\n    background-color: rgb(22, 13, 13);\n    overflow: hidden;\n}\n\n#root {\n    height: 100vh;\n    width: 100vw;\n}\n\n.menu-icon {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-right: 1.5px;\n}\n\n.compact-sidebar {\n  transition: width 0.3s ease;\n}\n\n@media (max-width: 1200px) {\n  .compact-sidebar {\n    width: 60px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
